import type { BoardTransform, DotPlaneBounds } from './board-transform';

type ViewportSize = { width: number; height: number };

function visibleBoardBounds(transform: BoardTransform, viewport: ViewportSize) {
  return {
    left: -transform.x / transform.scale,
    top: -transform.y / transform.scale,
    right: (viewport.width - transform.x) / transform.scale,
    bottom: (viewport.height - transform.y) / transform.scale,
  };
}

export function viewportDotPlaneBounds(
  transform: BoardTransform,
  viewport: ViewportSize,
  gridSize: number,
): DotPlaneBounds {
  const visible = visibleBoardBounds(transform, viewport);
  const horizontalMargin = viewport.width * .5 / transform.scale;
  const verticalMargin = viewport.height * .5 / transform.scale;
  const left = Math.floor((visible.left - horizontalMargin) / gridSize) * gridSize;
  const top = Math.floor((visible.top - verticalMargin) / gridSize) * gridSize;
  const right = Math.ceil((visible.right + horizontalMargin) / gridSize) * gridSize;
  const bottom = Math.ceil((visible.bottom + verticalMargin) / gridSize) * gridSize;
  return { left, top, width: right - left, height: bottom - top };
}

export function dotPlaneNeedsRecentering(
  bounds: DotPlaneBounds | null,
  transform: BoardTransform,
  viewport: ViewportSize,
  guardPixels = 64,
) {
  if (!bounds) return true;
  const visible = visibleBoardBounds(transform, viewport);
  const guard = guardPixels / transform.scale;
  return visible.left - guard < bounds.left
    || visible.top - guard < bounds.top
    || visible.right + guard > bounds.left + bounds.width
    || visible.bottom + guard > bounds.top + bounds.height;
}
